export default {
  headerContent: {
    title: 'Türk Nippon Sigorta Kasko Sigortası Teklifi Hesaplama',
    slogan: "Araç Kasko Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'ARAÇ KASKO SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Turk Nippon Sigorta Araç Kasko Sigortası',
    description: {
      title: 'Turk Nippon Sigorta Araç Kasko Sigortası Nedir? ',
      content: [
        'Kasko sigortası, taşıtınızı çarpma, çarpılma, devrilme, yangın ve hırsızlık risklerine karsı güvence altına almaktadır. İhtiyacınız olan araba sigortası miktarını gereksinimleriniz belirler. Ancak bunun ötesinde, gerçekte seçmeniz gereken teminat miktarı aynı zamanda bütçenize, arabanızın değerine ve araba sigortası primlerine ne kadar ödeyeceğinize bağlı olarak tercih ettiğiniz koruma düzeyi arasındaki değiş tokuşa da bağlıdır.',
        'Kasko Sigortası Hesaplayıcısı, araç sigortası maliyet tahminini yapar ve karşılaştırmayı zahmetsiz hale getirir. Hızlı bir tahmin alın, ardından en iyi kasko fiyatını ücretsiz olarak karşılaştırın!'
      ]
    },
    subContent: {
      title: 'Türk Nippon Sigorta Araç Kasko Sigortası Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            '',
          subList: [
            'Çarpma, çarpışma, devrilme',
            'Deprem ve yanardağ püskürmesi',
            'Grev, lokavt, kargaşalık, halk hareketleri ve terör',
            'Hırsızlık, hırsızlığa teşebbüs',
            'Hukuksal koruma',
            'Kemirgen hayvanların vereceği zararlar',
            'Kıymet kazanma',
            'Sel ve su baskını',
            'Sigara ve benzeri maddelerin temasıyla meydana gelen yangın dışındaki zararlar',
            'Yanma',
            'Yetkili olmayan kişilerce çekilen araçlara gelen zararlar',
            'Yurt dışı teminatı',
            'Hukuksal koruma teminatıdır.'
          ]
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Araç Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Araç Kasko Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Araç Kasko Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Araç Kasko Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Turk Nippon Sigorta Araç Kasko Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
